'use server';

import { redirect } from 'next/navigation';
import { z } from 'zod';
import { api, ApiError } from '@/lib/api';
import { setSession } from '@/lib/session';

const LoginSchema = z.object({
  email: z.string().email({ message: 'Bitte eine gültige E-Mail-Adresse eingeben.' }),
  password: z.string().min(8, { message: 'Mindestens 8 Zeichen.' }),
});

export interface LoginState {
  fieldErrors?: { email?: string[]; password?: string[] };
  formError?: string;
  values?: { email?: string };
}

export async function loginAction(
  _state: LoginState | undefined,
  formData: FormData,
): Promise<LoginState> {
  const email = String(formData.get('email') ?? '');
  const password = String(formData.get('password') ?? '');

  const parsed = LoginSchema.safeParse({ email, password });
  if (!parsed.success) {
    return {
      fieldErrors: z.flattenError(parsed.error).fieldErrors,
      values: { email },
    };
  }

  try {
    const { accessToken } = await api<{ accessToken: string }>('/auth/login', {
      method: 'POST',
      body: { email: parsed.data.email, password: parsed.data.password },
      authed: false,
    });
    await setSession(accessToken);
  } catch (err) {
    if (err instanceof ApiError && err.status === 401) {
      return { formError: 'E-Mail oder Passwort falsch.', values: { email } };
    }
    return {
      formError:
        err instanceof Error ? err.message : 'Login fehlgeschlagen, bitte erneut versuchen.',
      values: { email },
    };
  }

  redirect('/dashboard');
}
